<template>
    <div>
      <!-- :desc="'Güncelleme'+kariyeri.update" -->
     <navbar :title="fad" :box="box"/>

<div style="margin-bottom:2px" v-for="(item,index) in posts" :key="index"> 
  <van-cell style="background:#f2f2f2" :title="item.ad+' '+item.kariyer" icon="user-o" is-link :to="'detay/'+item.kod+'/'+item.ad" />
  <van-grid :column-num="4">
    <van-grid-item icon="friends-o" :text="item.kisi+ ' Kişi'" />
    <van-grid-item icon="award-o" :text="item.qv+ ' QV'+' '+item.durum" />
    <van-grid-item icon="vip-card-o" :text="item.kp+ ' KP'" />
    <van-grid-item icon="coupon-o" :text="item.kod.toString()" />
  </van-grid>
</div>
 
    <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
    </div>
</template>

<script>
import {helper} from '@/helper';
import { userService } from '@/plugins/_services';
import navbar from './nav'
import {Toast} from 'vant'
import {Dialog} from 'vant'
export default {
components:{
  navbar
},
  data() {
    return {
      activeName: '1',
      posts:[],
      show:false,
      uye_kod:helper.settings.ayar().uye,
      aay:parseInt(helper.settings.donem().ay),
      ayil:parseInt(helper.settings.donem().yil),      
      fad:'Organisazyon', // local db ye geçince local storage den gelecek,
      kod:helper.settings.ayar().uye,
      obje:[],
      obje2:[],
      derinlik:0,
      anakol:0,
      box:JSON.parse(localStorage.getItem('ayuBox')).baskets.length || 0,
      ay:helper.settings.donem().ay,
      yil:parseInt(helper.settings.donem().yil),
      toplamanakol:0
    };
  },
// watch: {
//         posts: {
//             handler: function (val) {
//               var kisi =0
//               val.forEach(element => {
//                 kisi+=element.kisi
//               });
//                if (val.length === 2 && kisi === this.obje.length ) {
//                  console.log("d "+this.obje.length)
//                  this.show = false
//                }
//             },
//             //deep: true
//         }
//     },  
  created (){
    this.show = true
    userService.handleResponse(helper.settings.ayar().username,helper.settings.ayar().pass)
    .then(res => {
      this.organisazyon(this.kod)
      })
    .catch(err => {userService.logout()})
  },
  methods : {

  organisazyon(){
      helper.request.get("organisazyon/"+this.uye_kod+"/"+this.aay+"/"+this.ayil)
      .then(res => {
            if (res.results.length === 0 ) this.show = false
            else{ this.hobbala(res.results,this.aay,this.ayil,0) 
            this.toplamanakol = res.results.length
            }
        })
  },

    hobbala(arg,ay,yil,anakol){
      var pross = 0
      for (let i = 0, p = Promise.resolve(); i < arg.length; i++) {
        p = p.then(_ => new Promise(resolve => {
          
          //setTimeout(() => {
          anakol++
          this.derinlik = 1
          let data = {
          kod:arg[i].uye_kod,
          ad:arg[i].uye_ad,
          derinlik : this.derinlik,
          anakol:anakol,
          qv:arg[i].qv,
          kp:arg[i].kp,
          ay:ay,
          yil:yil,
          sponsor:arg[i].ref_kod,
          kariyer:arg[i].kariyer
          }
          //console.log(data)
          this.obje.push(data)
           this.kol(data.kod,data.derinlik,anakol,ay,yil)
            .then(res => {
              pross++
              if(arg.length === pross){
                setTimeout(() => {
                  this.grupla(this.obje,ay,yil)
                  .then((response)=>{
                    //console.log(response)
                    response.forEach(element => {
                        helper.request.get("aktifmi/"+element.kod+"/"+ay+"/"+yil)
                        .then(res=>{
                          let data = {
                            ad:element.ad,
                            anakol:element.anakol,
                            kod:element.kod,
                            qv:element.qv,
                            kp:element.kp,
                            kisi:element.kisi,
                            kariyer:element.kariyer,
                            durum:'Pasif'
                          }
                          if (res>=80){data.durum ='Aktif'}
                          if (data.qv===null){data.qv =0}
                          if (data.kariyer===null){data.kariyer = 'Güncellememeiş'}
                          this.posts.push(data)
                          this.show = false
                        })
                    });
                  })
                }, 2000);
            }
              resolve()
            })


           }
        ))
      }

    },
    kol(kod,derinlik,anakol,ay,yil){
      return new Promise ((resolve,reject)=>{
        helper.request.get("organisazyon/"+kod+"/"+ay+"/"+yil)
        .then(res => {
          if (res.results.length===0){
            this.obje2 = []
            resolve(true)}
           else{
             derinlik++
              this.getProduct(res.results,derinlik,anakol,ay,yil)
               .then(res=>{
                 this.getProduct2().then(response => {
                   //setTimeout(() => {
                     resolve()
                   //},1000 );
                   
                 })
             })
            }
        })
      })
    },
    getProduct2(){
      return new Promise ((resolve,reject)=>{
        var pros = 0
        this.obje2.forEach((element) => { 
            this.kol(element.kod,element.derinlik,element.anakol,element.ay,element.yil)
            pros++
        });
        if (pros === this.obje2.length) resolve()
      })
    },
    getProduct(arg,derinlik,anakol,ay,yil){ // sabit arttıcı
    return new Promise ((resolve,reject)=>{
    this.obje2 = []
      var pros = 0
          arg.forEach((element,i) => {
              let data = {
                 kod:element.uye_kod,
                 derinlik : derinlik,
                 anakol:anakol,
                 qv:element.qv,
                 kp:element.kp,
                 ay:ay,
                 yil:yil,
                 ad:element.uye_ad,
                 sponsor:element.ref_kod,
                 kariyer:element.kariyer
               }
          this.obje.push(data)
          this.obje2.push(data)
          pros++
          });

        //  },500);
          if(arg.length === pros){
            resolve(true)
          }
      })
    },
    grupla(arr,ay,yil){
        return new Promise ((resolve,reject) => {

            var result = []
            var pros = 0 
            arr.forEach(function (a) {
              if ( !this[a.anakol] ) {
              this[a.anakol] = {ad:a.ad,anakol:a.anakol,kod:a.kod,qv:0,kp:0,kisi:0,durum:'Pasif',kariyer:a.kariyer};
                result.push(this[a.anakol]);
              }
              this[a.anakol].qv +=a.qv;
              this[a.anakol].kp +=a.kp;
              this[a.anakol].kisi++;
              pros++
            }, Object.create(null));
            resolve(result)
        }) 
    },
    trtgoster(uzuntarih){
      const monthNames = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12" ];
      const d = new Date(uzuntarih);
      return d.getDate() +'-'+ monthNames[d.getMonth()]+'-'+d.getFullYear();
    },

  }

};
</script>
<style scoped>
        .Aktif {
          color:'#dbf6e9',
        }
        .Pasif {
          color:'#ffdada',
        }
</style>


// WEBPACK FOOTER //
// src/components/agac.vue